/**
 * CPF/CNPJ: normalização e validação (espelha Projeto Base resources/js/utils/documentoBrasil.js).
 */

export function normalizarDigitos (val) {
  return String(val || '').replace(/\D/g, '')
}

export function validarCpf (val) {
  const c = normalizarDigitos(val)
  if (c.length !== 11 || /^(\d)\1{10}$/.test(c)) return false
  let soma = 0
  for (let i = 0; i < 9; i++) {
    soma += parseInt(c.charAt(i), 10) * (10 - i)
  }
  let resto = (soma * 10) % 11
  if (resto === 10 || resto === 11) resto = 0
  if (resto !== parseInt(c.charAt(9), 10)) return false
  soma = 0
  for (let i = 0; i < 10; i++) {
    soma += parseInt(c.charAt(i), 10) * (11 - i)
  }
  resto = (soma * 10) % 11
  if (resto === 10 || resto === 11) resto = 0
  return resto === parseInt(c.charAt(10), 10)
}

export function validarCnpj (val) {
  const c = normalizarDigitos(val)
  if (c.length !== 14 || /^(\d)\1{13}$/.test(c)) return false

  let tamanho = 12
  let numeros = c.substring(0, tamanho)
  let soma = 0
  let pos = tamanho - 7
  for (let i = tamanho; i >= 1; i--) {
    soma += parseInt(numeros.charAt(tamanho - i), 10) * pos--
    if (pos < 2) pos = 9
  }
  let resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11)
  if (resultado !== parseInt(c.charAt(12), 10)) return false

  tamanho = 13
  numeros = c.substring(0, tamanho)
  soma = 0
  pos = tamanho - 7
  for (let i = tamanho; i >= 1; i--) {
    soma += parseInt(numeros.charAt(tamanho - i), 10) * pos--
    if (pos < 2) pos = 9
  }
  resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11)
  return resultado === parseInt(c.charAt(13), 10)
}

export function formatarDocumento (val) {
  const d = normalizarDigitos(val)
  if (d.length === 11) {
    return `${d.substring(0, 3)}.${d.substring(3, 6)}.${d.substring(6, 9)}-${d.substring(9, 11)}`
  }
  if (d.length === 14) {
    return `${d.substring(0, 2)}.${d.substring(2, 5)}.${d.substring(5, 8)}/${d.substring(8, 12)}-${d.substring(12, 14)}`
  }
  if (d.length <= 11) {
    let s = d
    if (d.length > 9) s = `${d.substring(0, 3)}.${d.substring(3, 6)}.${d.substring(6, 9)}-${d.substring(9)}`
    else if (d.length > 6) s = `${d.substring(0, 3)}.${d.substring(3, 6)}.${d.substring(6)}`
    else if (d.length > 3) s = `${d.substring(0, 3)}.${d.substring(3)}`
    return s
  }
  let s = d
  if (d.length > 12) {
    s = `${d.substring(0, 2)}.${d.substring(2, 5)}.${d.substring(5, 8)}/${d.substring(8, 12)}-${d.substring(12)}`
  } else if (d.length > 8) {
    s = `${d.substring(0, 2)}.${d.substring(2, 5)}.${d.substring(5, 8)}/${d.substring(8)}`
  } else if (d.length > 5) {
    s = `${d.substring(0, 2)}.${d.substring(2, 5)}.${d.substring(5)}`
  } else if (d.length > 2) {
    s = `${d.substring(0, 2)}.${d.substring(2)}`
  }
  return s
}

/** Máscara v-mask: CPF ou CNPJ conforme quantidade de dígitos digitados. */
export function mascaraDocumentoLogin (valor) {
  const d = normalizarDigitos(valor)
  return d.length > 11 ? '##.###.###/####-##' : '###.###.###-##'
}

export function documentoValido (valor) {
  const d = normalizarDigitos(valor)
  if (d.length === 11) return validarCpf(d)
  if (d.length === 14) return validarCnpj(d)
  return false
}



// WEBPACK FOOTER //
// ./src/utils/documentoBrasil.js